import type { OffsiteConfig } from "@/engine/app/offsite-config";
import { SLIDE_COMPONENTS } from "./deck";
import "./tokens.css";

export const config: OffsiteConfig = {
  id: "vertrieb",
  displayName: "SVO Offsite Vertrieb",
  subdomain: "offsite.svoos.de",
  apiBaseUrl: "https://api.offsite.svoos.de",
  deck: SLIDE_COMPONENTS,
  // Entspricht der CUTS-Konstante des aktuell laufenden Vertrieb-Decks
  // (passt zur Deck-Reihenfolge in ./deck.ts: Workshop ab Folie 8, SVO OS
  // ab Folie 21, Reveal ab Folie 23).
  progressCuts: [
    { atSlide: 8, label: "Interaktiver Workshop", icon: "⚡" },
    { atSlide: 21, label: "SVO OS", icon: "◆" },
    { atSlide: 23, label: "Reveal", icon: "✨" },
  ],
  // Slide16OvernightAnkuendigung steht im Deck an 0-basiertem Index 8.
  overnightAnnouncementSlide: 8,
  phases: [
    "intro",
    "topics",
    "voting",
    "grouping",
    "working",
    "evaluating",
    "evaluated",
    "showcase",
    "reveal",
  ],
  ai: { evalPromptKey: "vertrieb", overnightPromptKey: "vertrieb" },
};
